import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formata um CPF para exibição (000.000.000-00).
 * Aceita string de 11 dígitos puros ou já formatada.
 *
 * Exemplos:
 *   '04915847102' → '049.158.471-02'
 *   null/undefined → '—'
 */
@Pipe({ name: 'cpf', standalone: true })
export class CpfPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (value == null || value === '') return '—';
    const digits = value.replace(/\D/g, '');
    if (digits.length !== 11) return value;
    return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9)}`;
  }
}
